import { translate } from "@/i18n";
import { onboardingMessages } from "@/i18n/messages/onboarding";

export type DenkerAgentVoiceId = "michael" | "george" | "eponine" | "eve";

type ToneKey = Extract<keyof typeof onboardingMessages.en, `tone${string}`>;

type DenkerAgentVoice = {
  id: DenkerAgentVoiceId;
  name: string;
  /** How the voice sounds, in the app language when it is read. */
  readonly tone: string;
  gender: "female" | "male";
};

function voice(
  id: DenkerAgentVoiceId,
  name: string,
  toneKey: ToneKey,
  gender: DenkerAgentVoice["gender"],
): DenkerAgentVoice {
  return {
    id,
    name,
    get tone() {
      return translate(onboardingMessages, toneKey);
    },
    gender,
  };
}

/** Shared voice names without loading the native speech controller. */
export const DENKER_AGENT_VOICES: DenkerAgentVoice[] = [
  voice("michael", "Michael", "toneClearWarm", "male"),
  voice("george", "George", "toneFriendlyLight", "male"),
  voice("eponine", "Eponine", "toneLightLively", "female"),
  voice("eve", "Eve", "toneBrightClear", "female"),
];

export function isDenkerAgentVoiceId(
  value: unknown,
): value is DenkerAgentVoiceId {
  return DENKER_AGENT_VOICES.some((voice) => voice.id === value);
}
